import { ref } from 'vue';
import EventDocumentsAPI from 'dashboard/api/planning/eventDocuments';

export function useEventDocuments(eventId) {
  const documents = ref([]);
  const loading = ref(false);
  const library = ref(null);
  const libraryLoading = ref(false);

  const eid = () =>
    typeof eventId === 'function' || eventId?.value !== undefined
      ? eventId.value ?? eventId()
      : eventId;

  const fetchDocuments = async () => {
    const id = eid();
    if (!id) {
      documents.value = [];
      return;
    }
    loading.value = true;
    try {
      const res = await EventDocumentsAPI.getAll(id);
      documents.value = res.data || [];
    } catch {
      documents.value = [];
    } finally {
      loading.value = false;
    }
  };

  const fetchLibrary = async (knowledgebaseId = null) => {
    libraryLoading.value = true;
    try {
      const res = await EventDocumentsAPI.getLibrary(knowledgebaseId);
      library.value = res.data;
    } catch {
      library.value = null;
    } finally {
      libraryLoading.value = false;
    }
  };

  const attachDocument = async payload => {
    const res = await EventDocumentsAPI.create(eid(), payload);
    documents.value = [res.data, ...documents.value];
    return res.data;
  };

  const updateDocument = async (id, payload) => {
    const res = await EventDocumentsAPI.update(eid(), id, payload);
    documents.value = documents.value.map(d =>
      d.id === id ? res.data : d
    );
    return res.data;
  };

  const removeDocument = async id => {
    await EventDocumentsAPI.destroy(eid(), id);
    documents.value = documents.value.filter(d => d.id !== id);
  };

  const sendDocument = async (id, payload) => {
    const res = await EventDocumentsAPI.sendDocument(eid(), id, payload);
    documents.value = documents.value.map(d =>
      d.id === id ? res.data : d
    );
    return res.data;
  };

  const remindDocument = async (id, payload) => {
    const res = await EventDocumentsAPI.remind(eid(), id, payload);
    documents.value = documents.value.map(d =>
      d.id === id ? res.data : d
    );
    return res.data;
  };

  const voidDocument = async id => {
    const res = await EventDocumentsAPI.voidDocument(eid(), id);
    documents.value = documents.value.map(d =>
      d.id === id ? res.data : d
    );
    return res.data;
  };

  return {
    documents,
    loading,
    library,
    libraryLoading,
    fetchDocuments,
    fetchLibrary,
    attachDocument,
    updateDocument,
    removeDocument,
    sendDocument,
    remindDocument,
    voidDocument,
  };
}
